import React, { useEffect, useState } from 'react';
import { Grid, TextField, Typography, Paper, Chip, InputBase } from '@material-ui/core';
import { DateTimePicker,MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import EventTwoToneIcon from '@material-ui/icons/Event';

import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  fieldLabel: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    },
    textSty: {
        '& .MuiOutlinedInput-input':{
            padding:'5px'
        }
    },
    table: {
        // minWidth: 400, // Adjust as needed
        border: "1px solid #ccc", // Border for table
      },
      tableHead: {
        backgroundColor: "#f5f5f5", // Light grey background for header
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    border: '1px solid #c4c4c4',
    borderRadius: theme.shape.borderRadius,
    padding:'10px',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  input: {
    flex: 1,
    minWidth: 120,
    border: 'none',
    outline: 'none',
  },
}));

const ProcedureSection = (props) => {
    const classes = useStyles();
    const { data, sample } = props;
  const [procedureNumber1, setProcedureNumber1] = useState(sample ? data?.procedureNumber :data?.procedureNumberStart);
  const [procedureNumber2, setProcedureNumber2] = useState(data?.procedureNumberEnd);

//   const [scheduledStartTime, setScheduledStartTime] = useState(data?.scheduledStartTime ? moment(data?.scheduledStartTime) : null);
  const [actualStartTime, setActualStartTime] = useState(data?.actualStartTime ? moment(data?.actualStartTime) : null);
//   const [scheduledEndTime, setScheduledEndTime] = useState(data?.scheduledEndTime ? moment(data?.scheduledEndTime) : null);
  const [actualEndTime, setActualEndTime] = useState(data?.actualEndTime ? moment(data?.actualEndTime) : null);

  const [chips, setChips] = useState(data?.keyEquipmentIDs ? data?.keyEquipmentIDs : []);
  const [inputValue, setInputValue] = useState('');

  const handleAddChip = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      setChips([...chips, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleDeleteChip = (chipToDelete) => {
    setChips((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const calculateDelay = () => {
    const start = actualEndTime ? data?.scheduledEndTime : actualStartTime ? data?.scheduledStartTime : data?.scheduledEndTime;
    const end = actualEndTime ? actualEndTime : actualStartTime;

    if (end) {
      const duration = moment.duration(moment(end).diff(moment(start)));
      
      // Extract hours and minutes
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
  
      return `${hours} hrs ${minutes} min`; // Format in hours and minutes
    }
  
    return 'N/A';
  };
    
    useEffect(() => {
        setProcedureNumber1(sample ? data?.procedureNumber :data?.procedureNumberStart)
        setProcedureNumber2(data?.procedureNumberEnd)
        // setScheduledStartTime(data?.scheduledStartTime ? moment(data?.scheduledStartTime) : null)
        setActualStartTime(data?.actualStartTime ? moment(data?.actualStartTime) : null)
        // setScheduledEndTime(data?.scheduledEndTime ? moment(data?.scheduledEndTime) : null)
      setActualEndTime(data?.actualEndTime ? moment(data?.actualEndTime) : null)
      setChips(data?.keyEquipmentIDs ? data?.keyEquipmentIDs : [])
    },[data.procedureNumber, data.procedureNumberStart, data.procedureNumberEnd, data.scheduledStartTime, data.actualStartTime, data.scheduledEndTime, data.actualEndTime])

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <div className={classes.root}>
              {/* Procedure Numbers Section */}
              <Grid container item xs={12} style={{ marginBottom:'1rem'}}>
          <Typography className={classes.fieldLabel} style={{marginRight:'6px'}}>Procedure Numbers </Typography>
          <Grid container >
            <Grid item xs={sample ? 12 : 3}>
              <TextField
                // fullWidth
                              style={{ padding: '5px' }}
                              className={classes.textSty}
                variant="outlined"
                value={procedureNumber1}
                // disabled={(data?.unitOperationStatus
                //   ? String(data?.unitOperationStatus).toLowerCase() === 'completed'
                //   : data?.qcSamplingStatus ?
                //     String(data?.qcSamplingStatus).toLowerCase() === 'completed'
                //     : false)}
                disabled
                // onChange={(e) => setProcedureNumber1(e.target.value)}
              />
            </Grid>
            {!sample && <>
              <Grid item xs={1} alignContent='center' style={{textAlign:'center'}}>
                      <Typography>to</Typography>
                  </Grid>
            <Grid item xs={3}>
                <TextField
                  // fullWidth
                              style={{ padding: '5px' }}
                              className={classes.textSty}
                variant="outlined"
                  value={procedureNumber2}
                  disabled
                  // disabled={(data?.unitOperationStatus
                  //   ? String(data?.unitOperationStatus).toLowerCase() === 'completed'
                  //   : data?.qcSamplingStatus ?
                  //     String(data?.qcSamplingStatus).toLowerCase() === 'completed'
                  //     : false)}
                // onChange={(e) => setProcedureNumber2(e.target.value)}
              />
              </Grid>
            </>}
                  
          </Grid>
          {!sample && 
          <Grid container style={{marginTop:'1rem'}} >
          <Grid item>
        <Typography className={classes.fieldLabel}>Key Equipment ID</Typography>
        <Paper className={classes.chipContainer}>
          {chips.map((chip, index) => (
            <Chip
              key={index}
              label={chip}
              disabled
              onDelete={() => handleDeleteChip(chip)}
              className={classes.chip}
            />
          ))}
          <InputBase
            title='Type and press enter to add the values'
            placeholder="Type and press enter to add the values"
                    className={classes.input}
                    disabled
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleAddChip}
            inputProps={{ style: { padding: 0 } }} // Prevent extra padding
          />
        </Paper>
      </Grid>
            </Grid>
          }
          
        </Grid>
        {!sample && <>
          {/* Delay Section */}
          <Grid container item xs={12} style={{flexDirection:'column', marginTop:'1rem', marginBottom:'1rem'}} >
          <Typography className={classes.fieldLabel}>Delay</Typography>
          <Typography>{calculateDelay()}</Typography>
          </Grid>

              {/* Scheduled Start and End Time Section */}
              <Grid container item xs={12} style={{ marginTop:'1rem', marginBottom:'1rem'}}>
              <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell>Scheduled Start Time</TableCell>
          <TableCell>Actual Start Time</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell  style={{whiteSpace:'nowrap'}}>
            {data?.scheduledStartTime ? moment(data.scheduledStartTime).format("DD-MMM-YYYY HH:mm:ss").toUpperCase():'-NA-'}
          </TableCell>
                  <TableCell>
                  {data?.actualStartTime ? moment(data.actualStartTime).format("DD-MMM-YYYY HH:mm:ss").toUpperCase() : '-NA-'}
                    {/* {data?.unitOperationStatus
                      && String(data?.unitOperationStatus).toLowerCase() === 'completed' ?
                      <>{data?.actualStartTime ? moment(data.actualStartTime).format("DD-MMM-YYYY HH:mm:ss") : '-NA-'}</>
                      :
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                                      <DateTimePicker
                                          fullWidth
                    // style={{ marginTop: '12px', width: '215px' }}
                    variant='inline'
                    inputVariant='outlined'
                                          // minDate={state.dateOfCollection}
                    title={actualStartTime ? actualStartTime.format("DD-MMM-YYYY HH:mm:ss") : "Choose date and time"}
                    format="DD-MMM-YYYY HH:mm:ss"
                    value={actualStartTime}
                    onChange={(date) => setActualStartTime(date)}
                    placeholder='Choose date and time'
                    size='small'
                    autoOk={true}
                    // minDate={new Date()}
                    InputProps={{
                      endAdornment: (
                        <EventTwoToneIcon
                          style={{
                            color: '#0000008a',
                            cursor: 'pointer',
                          }}
                        />
                      ),
                    }}
                  />
            </MuiPickersUtilsProvider>
                      } */}
            
          </TableCell>
        </TableRow>
      </TableBody>
                  </Table>
                  </Grid>
                  <Grid container item xs={12} style={{ marginTop:'1rem', marginBottom:'1rem'}}>
                  <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell>Scheduled End Time</TableCell>
          <TableCell>Actual End Time</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{whiteSpace:'nowrap'}}>
            {data?.scheduledEndTime ? moment(data.scheduledEndTime).format("DD-MMM-YYYY HH:mm:ss").toUpperCase():'-NA-'}
          </TableCell>
                  <TableCell>
                  {data?.actualEndTime ? moment(data.actualEndTime).format("DD-MMM-YYYY HH:mm:ss").toUpperCase() : '-NA-'}
                    {/* {data?.unitOperationStatus
                      && String(data?.unitOperationStatus).toLowerCase() === 'completed' ?
                      <>{data?.actualEndTime ? moment(data.actualEndTime).format("DD-MMM-YYYY HH:mm:ss") : '-NA-'}</>
                      :
<MuiPickersUtilsProvider utils={MomentUtils}>
                                      <DateTimePicker
                                          fullWidth
                    // style={{ marginTop: '12px', width: '215px' }}
                                          variant='inline'
                                          title={actualEndTime ? actualEndTime.format("DD-MMM-YYYY HH:mm:ss") : "Choose date and time"}
                    inputVariant='outlined'
                    // minDate={state.dateOfCollection}
                    format="DD-MMM-YYYY HH:mm:ss"
                    name='cellCollectionBagExpiryDate'
                    value={actualEndTime}
                    onChange={(date) => setActualEndTime(date)}
                    
                    placeholder='Choose date and time'
                    size='small'
                    autoOk={true}
                    // minDate={new Date()}
                    InputProps={{
                      endAdornment: (
                        <EventTwoToneIcon
                          style={{
                            color: '#0000008a',
                            cursor: 'pointer',
                          }}
                        />
                      ),
                    }}
                  />
            </MuiPickersUtilsProvider>
                  } */}
            
          </TableCell>
        </TableRow>
      </TableBody>
                  </Table>
                  </Grid>
        </>}
              
      </div>
    </MuiPickersUtilsProvider>
  );
}

export default ProcedureSection